import { render, staticRenderFns } from "./mandatory_form.vue?vue&type=template&id=1bb67f6c&scoped=true"
import script from "./mandatory_form.vue?vue&type=script&lang=js"
export * from "./mandatory_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb67f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb67f6c')) {
      api.createRecord('1bb67f6c', component.options)
    } else {
      api.reload('1bb67f6c', component.options)
    }
    module.hot.accept("./mandatory_form.vue?vue&type=template&id=1bb67f6c&scoped=true", function () {
      api.rerender('1bb67f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/transit_dealer_management/terminal_orders/form/mandatory_form.vue"
export default component.exports